import { PermissionValues as Permissions } from '@gripp/shared-logic';
import { ProductAlertCreate } from './components/productAlertCreate';
import { ProductAlertFormPage } from './components/productAlertFormPage';
import { ProductFileEdit } from './components/productFileEdit';
import { ProductFilePreviewPage } from './components/productFilePreview';
import { ProductRoutineAlerts } from './components/productRoutineAlerts';
import { ProductRoutinesAll } from './components/productRoutinesAll';
import { ProductRoutineSubmit } from './components/productRoutineSubmit';
import { Products } from './components/products';
import { ProductsFilterPage } from './components/productsFilterPage';
import { productsPaths } from './productsPaths';

export const productsRoutes = [
  {
    path: `${productsPaths.root}/:productId/routines/all`,
    element: <ProductRoutinesAll />,
    handle: {
      header: {
        titleKey: 'product.list.products',
        icon: 'tag',
      },
      requiredPermission: Permissions.product.all,
    },
  },
  {
    path: `${productsPaths.root}/:productId/routines/:routineId`,
    element: <ProductRoutineSubmit />,
    handle: {
      header: {
        titleKey: 'product.list.products',
        icon: 'tag',
      },
      requiredPermission: Permissions.product.all,
    },
  },
  {
    path: `${productsPaths.root}/:productId/alerts/new`,
    element: <ProductAlertCreate />,
    handle: {
      header: {
        titleKey: 'product.list.products',
        icon: 'tag',
      },
      requiredPermission: Permissions.product.all,
    },
  },
  {
    path: `${productsPaths.root}/:productId/alerts/:routineId/new`,
    element: <ProductAlertFormPage />,
    handle: {
      header: {
        titleKey: 'product.list.products',
        icon: 'tag',
      },
      requiredPermission: Permissions.product.all,
    },
  },
  {
    path: `${productsPaths.root}/:productId/alerts/:routineId/:alertId`,
    element: <ProductAlertFormPage />,
    handle: {
      header: {
        titleKey: 'product.list.products',
        icon: 'tag',
      },
      requiredPermission: Permissions.product.all,
    },
  },
  {
    path: `${productsPaths.root}/:productId/alerts/:routineId`,
    element: <ProductRoutineAlerts />,
    handle: {
      header: {
        titleKey: 'product.list.products',
        icon: 'tag',
      },
      requiredPermission: Permissions.product.all,
    },
  },
  {
    path: `${productsPaths.root}/:productId/files/:mediaId/edit`,
    element: <ProductFileEdit />,
    handle: {
      header: {
        titleKey: 'product.list.products',
        icon: 'tag',
      },
      requiredPermission: Permissions.product.all,
    },
  },
  {
    path: `${productsPaths.root}/:productId/files/:mediaId`,
    element: <ProductFilePreviewPage />,
    handle: {
      header: {
        titleKey: 'product.list.products',
        icon: 'tag',
      },
      requiredPermission: Permissions.product.all,
    },
  },
  {
    path: `${productsPaths.root}/*`,
    element: <Products />,
    handle: {
      header: {
        titleKey: 'product.list.products',
        icon: 'tag',
      },
      requiredPermission: Permissions.product.all,
    },
  },
  {
    path: `${productsPaths.root}/filters`,
    element: <ProductsFilterPage />,
    handle: {
      header: {
        titleKey: 'product.list.products',
        icon: 'tag',
      },
      requiredPermission: Permissions.globalAdmin,
    },
  },
];
